<template>
  <q-page padding>
    <div class="row col-12 align justify-between">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Associar EPI Especial a Função: {{ nomeGhe }}
      </p>

      <span style="cursor: pointer" class="row" @click="voltar">
        <q-icon
          @click="voltar"
          label="voltar"
          color="grey"
          size="sm"
          name="arrow_back_ios"
        />
        <span style="color: #8a8a8a; font-size: 16px">Voltar</span>
      </span>
    </div>

    <div class="row col-12 text-brand-5 text-weight-bold q-mt-md">
      <div class="col-2">
        <div>Unidade</div>
        <lista-unidades-select
          :disabled="true"
          v-model="selectedUnidade"
        ></lista-unidades-select>
      </div>
    </div>

    <div>
      <table-epi-regras />
    </div>

    <div>
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        :columns="columns"
        dense
        title="Selecione o(s) Grupo(s)"
        title-class="text-brand-5 text-weight-bold"
        selection="multiple"
        v-model:selected="selected"
        v-model:pagination="pagination"
        class="q-mt-md"
        row-key="name"
        hide-pagination
        hide-header
        grid
        @request="handleRequest"
      >
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtrar"
            type="text"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:item="props">
          <div
            class="q-pa-xs col-xs-12 col-sm-6 col-md-4 col-lg-3 grid-style-transition"
            :style="selected ? 'transform: scale(0.95);' : ''"
          >
            <q-card :class="selected ? 'bg-grey-2' : ''">
              <q-card-section>
                <q-checkbox
                  dense
                  v-model="selected"
                  :val="props.row.id"
                  :label="props.row.name"
                />
                <q-icon
                  class="q-ml-sm pointer"
                  name="visibility"
                  color="primary"
                  size="20px"
                  @click="verProdutos(props.row.id)"
                />
              </q-card-section>
              <q-separator />
            </q-card>
          </div>
        </template>
        <template #body-cell-epi="props">
          <q-td>
            <q-btn v-if="props" round color="positive" icon="headphones" />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md q-mb-lg">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
    <span class="q-table__title text-brand-5 text-weight-bold q-mt-lg"
      >Defina a nova regra
    </span>
    <div class="row col-12 q-gutter-sm q-mt-md text-brand-5 text-weight-bold">
      <div class="col-md">
        <div>Prazo Mínimo</div>
        <q-input
          dense
          outlined
          label="Prazo Mínimo (em dias)"
          v-model="regras.minimo"
          maxlength="4"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
      <div class="col-md">
        <div>Prazo Máximo</div>
        <q-input
          dense
          outlined
          label="Prazo Máximo (em dias)"
          v-model="regras.maximo"
          maxlength="4"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
      <div class="col-md">
        <div>Quantidade</div>
        <q-input
          dense
          outlined
          label="Quantidade"
          v-model="regras.quantidade"
          maxlength="8"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
      <div class="col-md">
        <div>Tipo</div>
        <q-select
          :options="tipo"
          dense
          outlined
          hide-bottom-space
          label="Tipo de Controle"
          v-model="regras.controle"
          :rules="[(val) => val || 'Campo Obrigatório']"
        />
      </div>
      <div class="col-md">
        <div>Crítico</div>
        <q-select
          :options="critico"
          dense
          outlined
          hide-bottom-space
          label="Crítico"
          v-model="regras.critico"
          :rules="[(val) => val || 'Campo Obrigatório']"
        />
      </div>
      <div>
        <p></p>
        <q-btn
          @click="criarRegra"
          color="positive"
          label="Criar Regra"
          class="q-mt-sm"
          no-caps
          icon="done"
        />
      </div>
    </div>
    <div>
      <div>
        <table-produtos-selecionados
          :id="idProdutos"
          :atualizar="getSecondTable"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "name",
    label: "Nome",
    field: "name",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, onMounted, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import TableProdutosSelecionados from "./../../grupoProdutos/components/TableProdutosSelecionados.vue";
import TableEpiRegras from "../components/TableEpiRegra.vue";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";

export default {
  props: ["unidades"],
  components: {
    TableProdutosSelecionados,
    TableEpiRegras,
    ListaUnidadesSelect,
  },
  setup(props) {
    const store = useStore();
    const rows = ref([]);
    const router = useRouter();
    const quasar = useQuasar();
    const disable = ref(true);
    const unidade = ref("");
    const selectedUnidade = ref();
    const route = useRoute();
    const id = route.params.id;
    const filtrar = ref("");
    const selected = ref([]);
    const idProdutos = ref("");
    const getSecondTable = ref(0);
    const nomeGhe = route.params.nome;
    const regras = ref({
      minimo: "",
      maximo: "",
      quantidade: "",
      controle: { label: "EMAIL E STATUS TROCA (WEB)", value: "ambos" },
      critico: "",
    });

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 15,
    });
    const getDados = async (page = 0, rowsPerPage = 8) => {
      disable.value = true;
      try {
        let response = await store.dispatch("processos/listarGrupo", {
          vendor_id: await store.state.org.unidadeData.id,
          id: id,
          page,
          per_page: rowsPerPage,
          search: filtrar.value,
        });

        rows.value = response.data.results.data;
        pagination.value.page = response.data.results.current_page;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;

        disable.value = false;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const criarRegra = async () => {
      if (selected.value.length == 0) {
        quasar.notify({
          message: "Selecione um grupo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      selected.value.forEach(async (value) => {
        try {
          await store.dispatch("processos/adicionarRegraFuncao", {
            group_id: value,
            vendor_id: store.state.org.unidadeData.id,
            minimum_days: regras.value.minimo,
            maximum_days: regras.value.maximo,
            amount: regras.value.quantidade,
            control_types: regras.value.controle.value,
            function_id: id,
            critico: regras.value.critico?.value,
          });

          quasar.notify({
            message: "Regra adicionada com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          resetarVariaveis();
        } catch (error) {
          quasar.notify({
            message:
              "Erro a o definir regra preencha todos os dados ou selecione um grupo",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      });
    };

    const resetarVariaveis = () => {
      regras.value = {
        minimo: "",
        maximo: "",
        quantidade: "",
        controle: { label: "EMAIL E STATUS TROCA (WEB)", value: "ambos" },
        critico: "",
      };
      selected.value = [];
    };

    const verProdutos = async (id) => {
      idProdutos.value = id;
      getSecondTable.value++;
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filtrar.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        unidade.value = store.state.org.unidadeData.id;
        getDados();
      }
    );

    watch(
      () => props.unidades,
      () => {
        unidade.value = "";
        getDados();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        selectedUnidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    const voltar = async () => {
      router.push({ name: "processos" });
    };
    return {
      rows,
      columns,
      getDados,
      unidade,
      pagination,
      resetarVariaveis,
      handleRequest,
      disable,
      filtrar,
      regras,
      criarRegra,
      verProdutos,
      idProdutos,
      getSecondTable,
      selectedUnidade,
      voltar,
      tipo: [
        {
          label: "EMAIL E STATUS TROCA (WEB)",
          value: "ambos",
        },
        {
          label: "NENHUM",
          value: "nenhum",
        },
        {
          label: "SOMENTE EMAIL",
          value: "email",
        },
        {
          label: "SOMENTE STATUS TROCA (WEB)",
          value: "farol",
        },
      ],
      critico: [
        {
          label: "Sim",
          value: "1",
        },
        {
          label: "Não",
          value: "0",
        },
      ],
      nomeGhe,
      selected,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style lang="sass">
.grid-style-transition
  transition: transform .28s, background-color .28s
</style>

<style>
.align {
  align-items: center;
}

.pointer {
  cursor: pointer;
}

p {
  margin: 0px;
}
</style>
